import {Box} from "@mui/material";
import {useState} from "react";
import OriginalCalendar from "../OriginalCalendar.jsx";
import {Helmet} from "react-helmet";
import {OriginalCalendarURI} from "../Button/OriginalCalendarButton.jsx";

import {Crumbs} from "../Crumbs.jsx";
import { LatestAnnouncement } from "./Announcement.jsx";
import ReactGA from "react-ga4";
import WhiteElephantDialog from "../Dialog/WhiteElephant.jsx";

const title = "Pro Austin 2-Step Calendar";
const desc = "6 weeks of easy scrollin, boot scootin', 2-steppin' events. Great for dancers that already know all the venues and bands."

export const OriginalCalendarPage = () => {

     const [whiteElephantOpen, setWhiteElephantOpen] = useState(false)

    return <Box>
        <Helmet>
            <meta charSet="utf-8"/>
            <meta property="og:description" content={desc}/>
            <meta property="twitter:title" content={title}/>
            <meta property="twitter:description" content={desc}/>
            <title>{title}</title>
            <meta property="description" content={desc} />
            <link rel="canonical" href={OriginalCalendarURI}/>
        </Helmet>
        {/*<PatreonAlert />*/}
        <Crumbs crumbs={[
        
            { title: "Where to Dance", href: "/where-to-dance" },
            { title: "Pro Calendar" }
        ]} />
        <LatestAnnouncement /> 
       {/* <Box align="center" marginBottom={2}>
            <a 
                onClick={() => setWhiteElephantOpen(true)}
                href="#"
            >
                <img src="/images/white-elephant-button.gif" alt="White Elephant" width={350}/>
            </a>
        </Box> */}
        <OriginalCalendar showFilters={true}/>
        <WhiteElephantDialog open={whiteElephantOpen} onClose={() => setWhiteElephantOpen(false)}/>
        
    </Box>
}